import { TemplatedReportsListRoutePath } from "#src/routes/reports/templated-reports";
import { RoutePath } from "#src/utils/route";

export const TemplatedReportsTemplateRoutePath =
  TemplatedReportsListRoutePath.concat(
    new RoutePath({
      path: "/template",
      title: "Template",
      isPresentational: true,
    })
  );
